module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerm"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("By Steve R Dunn")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Power and the Glory: Royal Navy Fleet Reviews from Earliest Times to 2005")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Battle in the Baltic: The Royal Navy and the Fight to Save Estonia and Latvia, 1918–1920")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Thunder: The Royal Navy and the Scandinavian Trade in World War One")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bayly’s War: The Battle for the Western Approaches in the First World War")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Securing the Narrow Sea: The Dover Patrol, 1914–1918")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blockade: Cruiser warfare and the starvation of Germany in World War One")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Formidable: A true story of disaster and courage")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Coward? The rise and fall of the Silver King")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Scapegoat: The life and tragedy of a fighting admiral and Churchill’s role in his death")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95808628","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Frontmatter01.vue
// module id = 60
// module chunks = 0